import type { FeedPresentation } from "@/generated/api/types.gen"

export type Palette = NonNullable<FeedPresentation["palette"]>

export const PALETTES = ["brand", "pink", "ember", "ocean", "gold", "slate"] as const satisfies readonly Palette[]

type MissingPalette = Exclude<Palette, (typeof PALETTES)[number]>
const _palettesExhaustive: MissingPalette extends never ? true : never = true
void _palettesExhaustive

export const isPalette = (value: string | undefined | null): value is Palette => value != null && (PALETTES as readonly string[]).includes(value)

const PALETTE_CLASS: Record<Palette, string> = {
  brand: "",
  pink: "palette-pink",
  ember: "palette-ember",
  ocean: "palette-ocean",
  gold: "palette-gold",
  slate: "palette-slate",
}

const paletteClass = (palette: Palette = "brand") => PALETTE_CLASS[palette]

export const withPalette = (palette: Palette | undefined, className?: string) => `${paletteClass(palette)} ${className ?? ""}`.trim()
